import React from 'react';
import { MonsterStatBreakdown, SkillBreakdown } from '../api';

type Breakdown = SkillBreakdown | MonsterStatBreakdown;

interface StatBreakdownProps {
  breakdown?: Breakdown;
  getModifierImage?: (source?: string, sourceType?: string | null) => string | undefined;
  emptyLabel?: string;
  className?: string;
}

const StatBreakdown: React.FC<StatBreakdownProps> = ({ breakdown, emptyLabel = 'No bonuses', className }) => {
  if (!breakdown) return null;

  const modifiers = breakdown.modifiers || [];
  const modsSum = modifiers.reduce((sum, m) => sum + (m.value ?? 0), 0);
  const blockClass = `skill-breakdowns single${className ? ` ${className}` : ''}`;

  return (
    <div className={blockClass}>
      <div className="skill-breakdown-row">
        <div className="skill-breakdown-header">
          <span className="skill-total">
            {breakdown.base} {modsSum ? `+ ${modsSum} = ${breakdown.total}` : ''}
          </span>
        </div>
        {modifiers.length ? (
          <div className="skill-mod-list">
            {modifiers.map((m, idx) => (
              <div key={idx} className="skill-mod-chip">
                <span className="mod-source">{m.source || 'Source'}</span>
                <span className="mod-value">{m.value > 0 ? `+${m.value}` : m.value}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="skill-mod-none">{emptyLabel}</div>
        )}
      </div>
    </div>
  );
};

export default StatBreakdown;
